<template>
    <div class="aside-container">
        <div class="aside-menu">
            <ul class="aside-menu-box">
                <li v-for="(item,index) in menuList" :key="index" :class="activeName==item.name?'active':''" @click="menuClick(item,index)">
                    <div class="aside-menu-box-inner">
                        <img :src="activeName==item.name?item.icon:item.activeIcon" />
                        <span>{{item.label}}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="aside-footer">
            <ul class="aside-footer-box">
                <li @click="recordClick" :class="activeName=='workHistory'?'active':''">
                    <div class="aside-footer-box-inner">
                        <img src="@/assets/img/jilu-a.png" v-if="activeName=='workHistory'" />
                        <img src="@/assets/img/jilu.png" v-if="activeName!='workHistory'" />
                        <span>作文记录</span>
                    </div>
                </li>
                <li @click="sourceClick" :class="activeName=='sourceMaterialMy'?'active':''">
                    <div class="aside-footer-box-inner">
                        <img src="@/assets/img/grsucai-a.png" v-if="activeName=='sourceMaterialMy'" />
                        <img src="@/assets/img/grsucai.png" v-if="activeName!='sourceMaterialMy'" />
                        <span>个人素材库</span>
                    </div>
                </li>
                <li>
                    <el-popover popper-class="aside-footer-popover" placement="right" trigger="click">
                        <template #reference>

                            <div class="aside-footer-box-inner">
                                <img src="@/assets/img/xiazai.png" />
                                <span>APP下载</span>
                            </div>
                        </template>
                        <div class="aside-footer-scan">
                            <div>
                                <div class="aside-footer-scan-img">
                                    <img :src="configObj.ANDROID_DOWN_URL" />
                                </div>
                                <div>安卓版扫码下载</div>
                            </div>
                            <div>
                                <div class="aside-footer-scan-img">
                                    <img :src="configObj.IOS_DOWN_URL" />
                                </div>
                                <div>IOS版扫码下载</div>
                            </div>
                        </div>
                    </el-popover>
                </li>
                <li @click="popupShow=true">
                    <div class="aside-footer-box-inner">
                        <img src="@/assets/img/kefu.png" />
                        <span>联系客服</span>
                    </div>
                </li>
            </ul>
        </div>

        <el-dialog v-model="popupShow" title="开悟作文在线客服" width="300px" center>
            <div class="popup-inner online-inner">
                <div class="online-popup">
                    工作时间：周一至周五 9:00-18:00
                </div>
                <div class="online-popup">
                    客服电话：{{configObj.customerPhone}}
                </div>
                <div class="online-qrcode">
                    <img :src="configObj.customer_code" />
                </div>
                <div>扫描二维码联系在线客服</div>
            </div>
        </el-dialog>
    </div>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, watch } from 'vue';
import { useStore } from "vuex"
import { useRouter, useRoute } from 'vue-router';
import { ElMessage } from 'element-plus'
import { getConfigByCode, getConfigByCodeV1 } from "@/api/common.js"
const router = useRouter();
const route = useRoute();
const store = useStore();
const userInfo = ref(store.state.userInfo)
const configPhone = ref('')
const configObj = ref({
    customer_code: '',
    ANDROID_DOWN_URL: '',
    IOS_DOWN_URL: '',
    customerPhone: ''
})
const menuList = [
    {
        label: '作文秒评',
        path: '/composition/correct',
        name: 'correct',
        icon: require("@/assets/img/pingyue.png"),
        activeIcon: require("@/assets/img/pingyue-a.png")
    },
    {
        label: 'AI+开悟作文',
        path: '/composition/teaching',
        name: 'teaching',
        icon: require("@/assets/img/jiaoxue.png"),
        activeIcon: require("@/assets/img/jiaoxue-a.png")
    },
    {
        label: '开悟微课',
        icon: require("@/assets/img/weike.png"),
        activeIcon: require("@/assets/img/weike-a.png")
    },
    {
        label: 'AI润色',
        path: '/composition/polish',
        name: 'polish',
        icon: require("@/assets/img/runse.png"),
        activeIcon: require("@/assets/img/runse-a.png")
    },
    {
        label: '三步九法AI点拨',
        path: '/composition/guide',
        name: 'guide',
        icon: require("@/assets/img/zhidao.png"),
        activeIcon: require("@/assets/img/zhidao-a.png")
    },
    {
        label: '中/高考指导',
        icon: require("@/assets/img/kaoshi.png"),
        activeIcon: require("@/assets/img/kaoshi-a.png")
    },
    {
        label: 'AI范文',
        path: '/composition/modelEssay',
        name: 'modelEssay',
        icon: require("@/assets/img/fanwen.png"),
        activeIcon: require("@/assets/img/fanwen-a.png")
    },
    // {
    //     label: '作文重写',
    //     icon: require("@/assets/img/chongxie.png"),
    //     activeIcon: require("@/assets/img/chongxie-a.png")
    // },
    {
        label: '作文真题',
        path: '/composition/pastExamPaper',
        name: 'pastExamPaper',
        icon: require("@/assets/img/zhenti.png"),
        activeIcon: require("@/assets/img/zhenti-a.png")
    },
    {
        label: '写作素材',
        path: '/composition/sourceMaterial',
        name: 'sourceMaterial',
        icon: require("@/assets/img/sucai.png"),
        activeIcon: require("@/assets/img/sucai-a.png")
    },
    // {
    //     label: 'AI作文',
    //     icon: require("@/assets/img/zuowen.png"),
    //     activeIcon: require("@/assets/img/zuowen-a.png")
    // }
]
const activeName = ref('correct')
const popupShow = ref(false)
const loginShow = ref(false)
watch(() => route.path, (newPath, oldPath) => {
    activeName.value = route.name;

}, {
        immediate: true
    });
function menuClick(item: { label: string, name: string, path: string }) {
    if (item.name != activeName.value) {
        if (!userInfo.value.userId) {
            if (!['/composition/teaching', '/composition/pastExamPaper'].includes(item.path)) {
                return store.dispatch('setLoginFlag')
            } else {
                router.push(item.path)
            }
        }
        if (item.label == '作文重写') {
            router.push('/composition/workHistory')
        }else if(!item.path){
            ElMessage.warning('功能暂未开放！');
        } else {
            router.push(item.path)
        }

    }
}
function getConfig(flag) {
    getConfigByCode(flag).then(res => {
        configObj.value[flag] = res.data;
    })
}

function getConfigV1(flag) {
    getConfigByCodeV1(flag).then(res => {
        configObj.value[flag] = res.data.fileUrl;
    })
}

function recordClick() {
    let obj = {
        label: '作文记录',
        path: '/composition/workHistory',
        name: 'workHistory'
    }
    menuClick(obj)
}
function sourceClick() {
    let obj = {
        label: '个人素材库',
        path: '/composition/sourceMaterialMy',
        name: 'sourceMaterialMy'
    }
    menuClick(obj)
}
onMounted(() => {
    getConfig('customerPhone')
    getConfigV1('customer_code')
    getConfigV1('ANDROID_DOWN_URL')
    getConfigV1('IOS_DOWN_URL')
})
</script>
<style lang="scss" scoped>
.aside-container {
    min-width: 200px;
    height: calc(100vh - 60px);
    position: relative;
    .aside-footer {
        width: 100%;
        height: 200px;
        position: absolute;
        left: 0;
        bottom: 0;
        .aside-footer-box {
            margin: 20px;
            padding-top: 20px;
            border-top: 1px solid #eee;
            li {
                height: 35px;
                line-height: 35px;
                cursor: pointer;
                .aside-footer-box-inner {
                    width: 130px;
                    margin: auto;
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                }
                &.active {
                    background: #ef8b25;
                    color: #fff;
                    border-radius: 8px;
                }
                img {
                    width: 22px;
                    height: 22px;
                    margin-right: 5px;
                }
            }
        }
    }
    .aside-menu {
        padding-top: 20px;
        .aside-menu-box {
            padding: 0 15px;
            li {
                height: 35px;
                line-height: 35px;
                cursor: pointer;
                .aside-menu-box-inner {
                    width: 130px;
                    margin: auto;
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                }
                &.active {
                    background: #ef8b25;
                    color: #fff;
                    border-radius: 8px;
                }
                img {
                    width: 22px;
                    height: 22px;
                    margin-right: 5px;
                }
            }
        }
    }
}

.online-inner {
    text-align: center;
    line-height: 40px;
}

.online-popup {
    text-align: left;
}

.online-qrcode {
    width: 100%;
    height: auto;
    img {
        width: 100%;
        height: 100%;
    }
}
</style>
<style lang="scss">
.el-popover.el-popper.aside-footer-popover {
    width: 340px !important;
    .aside-footer-scan {
        display: flex;
        text-align: center;
        .aside-footer-scan-img {
            width: 150px;
            height: 150px;
            background: #ddd;
            margin-bottom: 10px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        &>div+div {
            margin-left: 15px;
        }
    }
}
</style>
